export const INPUT_PATTERN = /^[A-Za-z0-9 \-/_]*$/;
export const INPUT_MIN_LENGTH = 3;
export const REFERENCE_NUMBER_MAX_LENGTH = 30;
export const POSTAL_CODE_MAX_LENGTH = 20;

const getLengthErrorMessage = (
  value: string,
  translate: (key: string) => string,
  maxLength: number
): string | undefined => {
  if (value.length === 0) return undefined;
  if (value.length > maxLength) {
    return translate('Please enter a shorter value.');
  }
  if (value.length < INPUT_MIN_LENGTH) {
    return translate('Please enter the full value.');
  }
  return undefined;
};

export const isValidInput = (value: string): boolean =>
  value.length >= INPUT_MIN_LENGTH &&
  value.length <= REFERENCE_NUMBER_MAX_LENGTH;

export const isValidPostalCodeInput = (value: string): boolean =>
  value.length >= INPUT_MIN_LENGTH &&
  value.length <= POSTAL_CODE_MAX_LENGTH &&
  INPUT_PATTERN.test(value);

export const getInputErrorMessage = (
  value: string,
  translate: (key: string) => string
): string | undefined =>
  getLengthErrorMessage(value, translate, REFERENCE_NUMBER_MAX_LENGTH);

export const getPostalCodeErrorMessage = (
  value: string,
  translate: (key: string) => string
): string | undefined => {
  const baseError = getLengthErrorMessage(value, translate, POSTAL_CODE_MAX_LENGTH);
  if (baseError) return baseError;
  if (value.length > 0 && !INPUT_PATTERN.test(value)) {
    return translate('Unsupported characters detected. Remove symbols to continue.');
  }
  return undefined;
};
